export enum CredentialStatus {
  Active = 'Active',
  Inactive = 'Inactive',
  Manual = 'Manual',
  PreIssue = 'PreIssue',
  ActiveRenewalPeriod = 'ActiveRenewalPeriod',
  InactiveRenewalPeriod = 'InactiveRenewalPeriod',
}
